import React from 'react';
import { Helmet } from 'react-helmet-async';

const EmergencySpecial = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>$99 Emergency Dental Exam | Same-Day Appointments | Fort Worth Dental</title>
        <meta name="description" content="Emergency dental care - only $99 exam and X-ray! Same-day appointments available. Toothache, broken tooth, dental pain relief. Fort Worth TX. Call (817) 985-3337." />
        <link rel="canonical" href="https://fortworthdental.com/specials/emergency" />
      </Helmet>
      <section className="bg-gradient-to-br from-red-600 to-red-800 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">$99 Emergency Exam and X-Ray</h1>
          <p className="text-2xl">Affordable Dental Services When You Need Them Most</p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-red-50 p-12 rounded-lg mb-12 text-center">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Emergency Dental Care Special</h2>
            <div className="text-6xl font-bold text-red-600 mb-4">$99</div>
            <p className="text-2xl text-gray-700 mb-4">Emergency Exam + X-Ray</p>
            <p className="text-gray-600">Regular Value: $200+</p>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 mb-12">
            <h3 className="text-xl font-bold text-gray-800 mb-2">⚠️ Dental Emergency? We're Here to Help</h3>
            <p className="text-gray-700">
              Don't wait when you're in pain. Our emergency dental services provide fast relief when you need it most.
            </p>
          </div>

          <section className="mb-12">
            <h3 className="text-3xl font-bold text-gray-800 mb-6">When to Seek Emergency Dental Care:</h3>
            <ul className="space-y-3 text-gray-700 text-lg">
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-xl">•</span>
                <span>Severe toothache or dental pain</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-xl">•</span>
                <span>Knocked-out or broken tooth</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-xl">•</span>
                <span>Lost filling or crown</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-xl">•</span>
                <span>Abscess or infection</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-xl">•</span>
                <span>Swelling in the mouth or face</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-xl">•</span>
                <span>Bleeding that won't stop</span>
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h3 className="text-3xl font-bold text-gray-800 mb-6">What's Included in Your $99 Emergency Visit:</h3>
            <ul className="space-y-4 text-gray-700 text-lg">
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-2xl">✓</span>
                <span>Emergency examination by our experienced dentists</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-2xl">✓</span>
                <span>X-rays to diagnose the problem</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-2xl">✓</span>
                <span>Pain assessment and relief options</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-2xl">✓</span>
                <span>Treatment recommendations</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 text-2xl">✓</span>
                <span>Cost estimate for necessary treatment</span>
              </li>
            </ul>
          </section>

          <div className="bg-gradient-to-r from-red-600 to-red-700 text-white p-12 rounded-lg text-center">
            <h3 className="text-3xl font-bold mb-4">🔴 Call Now for Emergency Dental Care</h3>
            <p className="text-xl mb-8">We offer same-day appointments for dental emergencies</p>
            <a href="tel:8179853337" className="bg-white text-red-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 inline-block">
              Call (817) 985-3337 NOW
            </a>
            <p className="text-sm mt-4 opacity-90">*Emergency exam and X-ray only. Additional treatment fees may apply.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencySpecial;